export default __webpack_public_path__ + "static/media/encuesta.83c811fd.png";